var _excluded = ["children", "withClose", "onClose", "variant"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import styled, { css } from 'styled-components';
import { Iclose } from '../AgroIcon/icons';
import { AgroIconButton } from '../AgroIconButton';
import { Box } from '../Box';
var AgroTag = withCssProps(function (_ref) {
  var children = _ref.children,
    _ref$withClose = _ref.withClose,
    withClose = _ref$withClose === void 0 ? false : _ref$withClose,
    onClose = _ref.onClose,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'secondary' : _ref$variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var iColor = {
    secondary: 'gray800',
    primary: 'green900',
    outline: 'blue600'
  };
  var handleClose = function handleClose(event) {
    event.preventDefault();
    if (onClose) {
      onClose();
    }
  };
  return /*#__PURE__*/React.createElement(Tag, _extends({
    variant: variant
  }, props, {
    withClose: withClose
  }), children, withClose && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(StyledButton, {
    onClick: function onClick(e) {
      return handleClose(e);
    }
  }, /*#__PURE__*/React.createElement(Iclose, {
    width: "16px",
    height: "16px",
    fill: iColor[variant]
  }))));
});
AgroTag.propTypes = {
  withClose: PropTypes.bool,
  variant: PropTypes.oneOf(['primary', 'secondary', 'outline']),
  children: PropTypes.node,
  onClose: PropTypes.func
};
AgroTag.displayName = 'AgroTag';
export { AgroTag };
var Tag = styled.div.withConfig({
  displayName: "AgroTag__Tag",
  componentId: "ayip8b-0"
})(["justify-content:center;align-items:center;display:inline-flex;font-weight:500;font-size:12px;line-height:18px;border-radius:16px;font-family:", ";padding:", ";cursor:pointer;", " ", " ", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily;
}, function (_ref3) {
  var withClose = _ref3.withClose;
  return withClose ? '4px 12px' : '7px 12px';
}, function (_ref4) {
  var variant = _ref4.variant,
    theme = _ref4.theme;
  return variant === 'secondary' && css(["background:", ";color:", ";&:hover:not(:active),&:focus{background-color:", ";}&:active{background-color:", ";}"], theme.colors.gray300, theme.colors.gray800, theme.colors.gray400, theme.colors.gray500);
}, function (_ref5) {
  var variant = _ref5.variant,
    theme = _ref5.theme;
  return variant === 'primary' && css(["background:", ";color:", ";&:hover:not(:active),&:focus{background-color:", ";}&:active{background-color:", ";}"], theme.colors.green50, theme.colors.green900, theme.colors.green100, theme.colors.green200);
}, function (_ref6) {
  var variant = _ref6.variant,
    theme = _ref6.theme;
  return variant === 'outline' && css(["background:", ";color:", ";border:1px solid ", ";&:hover:not(:active),&:focus{background-color:", ";}&:active{background-color:", ";}"], theme.colors.white, theme.colors.blue600, theme.colors.blue600, theme.colors.blue50, theme.colors.blue50);
});
var StyledButton = styled(AgroIconButton).withConfig({
  displayName: "AgroTag__StyledButton",
  componentId: "ayip8b-1"
})(["padding:2px;margin-left:4px;display:flex;"]);